import { CASES_LIST } from '../index.js';
import CasesCard from './CasesCard';
export default {
  components: {
    CasesCard
  },
  data() {
    return {
      casesList: CASES_LIST
    };
  }
};